import httpService from "../httpService";

export default {
  findByHcCaseMaster(hcCaseMasterId) {
    return httpService.get("/hcCasePhongHop/findByHcCaseMaster", {
      params: { hcCaseMasterId }
    });
  },

  findById(id) {
    return httpService.get(`/hcCasePhongHop/${id}`);
  }
};



// WEBPACK FOOTER //
// ./src/services/phonghop/hcCasePhongHopService.js